import React, { useEffect, useState, useRef } from 'react';
import LazyLoad from 'react-lazyload';
import QuickJump from '../comps/quick-jump';
import vm from '../../static/js/unit';
import List from '../list';
import './index.scss';
import Base from '../../base';

const Brand = ({params}) => {
  // 接口返回内容
  const [data, setData] = useState([]);
  const [brandData, setBrand] = useState({id: 0, logo: '', name: ''});
  const [show, setShow] = useState(false);
  const [hot, setHot] = useState([]);

  const liRefList = useRef([]);
  const getRef = (dom) => {
    // NOTE: ref 在组件卸载时会null,防止内存泄漏
    if (dom) {
      liRefList.current.push(dom);
    }
  }
  // 右侧字母数据
  const letters = [];
  for (let i = 0; i < data.length; i++) {
    letters.push(data[i].fl);
  }
  useEffect(() => {
    const isev = params.ev === "isEv" ? 1 : 0;
    vm.ajax({
      url: process.env.REACT_APP_CHENGDU + 'getBrandList',
      data: {
        showid: process.env.REACT_APP_CHEZHAN_ID,
        isev: isev,
      },
      success(res) {
        setData(res.result);
      }
    });
    vm.ajax({
      url: process.env.REACT_APP_CHENGDU + 'getHotBrand',
      data: {
        showid: process.env.REACT_APP_CHEZHAN_ID,
        isev: isev,
      },
      success(res) {
        const list = res.result;
        if (list.length > 10) list.length = 10;
        setHot(list);
      }
    });
  }, [params.ev]);

  const handleClick = (brand) => {
    const {id, logo, name, hot} = brand;
    setBrand({id: id, logo: logo, name: name});
    setShow(true);
    document.body.style.overflow = 'hidden';
    Base.tongji('brandclick', {
      position: params.ev === "isEv" ? 'ev' : 'all',
      name: name,
      hot: !!hot,
    });
  };
  return (
    <List brand={brandData} show={show} setShow={setShow} tab={params.ev}>
      {
        hot.length > 0 && <section className="findcar-index-hot">
          {
            <>
              <p className="findcar-index-hot__caption">热门品牌</p>
              {
                hot.map(item => {
                  return <div key={item.brandid + 'hot'} className="findcar-index-hot__item" onClick={() => handleClick({id: item.brandid, name: item.brandname, logo: item.logo, hot: 1})}>
                    <img src={item.logo} alt={item.brandname} />
                    <span>{item.brandname}</span>
                  </div>
                })
              }
            </>
          }
        </section>
      }
      {
        data.length > 0 && <section className="findcar-index-brand">
          {
            data.map(group => {
              return <React.Fragment key={group.fl}>
                <div ref={getRef} className="findcar-index-brand__caption" id={`letter_${group.fl}`}>
                  {group.fl}
                </div>
                <ul>
                  {
                    group.list && group.list.map(brand => {
                      return <li key={brand.id} onClick={() => handleClick(brand)}><div className="item">
                        <LazyLoad once offset={100}>
                          <img src={brand.logo} alt={brand.name} />
                        </LazyLoad>
                        <span>{brand.name}</span></div>
                      </li>
                    })
                  }
                </ul>
              </React.Fragment>
            })
          }
        </section>
      }
      {
        data.length > 0 && <QuickJump
          letters={letters}
          liRefList={liRefList}
          contentOffsetTop={12}
        />
      }
    </List>
  )
}

export default Brand;